<template>
  <div class="menuList hp-100">
    <el-aside :width="isCollapse ? '64px' : '200px'">
      <el-scrollbar
        wrap-class="scrollbar-wrapper"
        :native="false"
        wrap-style="color: red; height:858px;overflow-x: hidden;"
      >
        <el-menu
          background-color="#fff"
          text-color="#222222"
          active-text-color="#17757A"
          :collapse="isCollapse"
          :collapse-transition="false"
          router
          :unique-opened="true"
          :default-active="activePath"
        >
          <template v-for="item in menuList">
            <!-- 一级菜单 -->
            <router-link :to="item.url" :key="item.id" v-if="item.children.length === 0">
              <div
                class="superior"
                v-if="item.icon && item.authName !== '驾驶舱' && item.authName !== '菁亿用户'"
              >
                <!-- 有图标并且不是驾驶舱 -->
                <!-- <div v-if="item.icon" class="superior"> -->
                <!-- <i :class="item.icon" class="iconfont" /> -->
                <img class="img" :src="item.icon" alt="" />

                <!-- <div v-else class="stance"></div> -->
                <span>{{ item.authName }}</span>
              </div>
              <el-menu-item :index="item.url + ''" v-else>
                <!-- <i :class="item.icon" class="iconfont" /> -->

                <img class="img" v-if="item.icon" :src="item.icon" alt="" />
                <div class="stance" v-else></div>
                <span>{{ item.authName }}</span>
              </el-menu-item>
            </router-link>
            <el-submenu
              v-else
              :key="item.id"
              class="one"
              :index="item.id + ''"
              @click.stop="handleClick(item)"
            >
              <!-- 一级菜单模板区域 -->
              <template slot="title">
                <!-- 图标 -->
                <i :class="item.icon" class="iconfont" />
                <img class="img" :src="item.icon" alt="" />
                <!-- 文本 -->
                <span>{{ item.authName }}</span>
              </template>
              <!-- 二级菜单 -->
              <el-menu-item
                v-for="subItem in item.children"
                :key="subItem.id"
                :index="subItem.url"
                @click="saveNavState(subItem.url)"
              >
                <!--  v-if="!subItem.type == '3'" -->
                <template slot="title">
                  <span>{{ subItem.authName }}</span>
                </template>
              </el-menu-item>
            </el-submenu>
          </template>
        </el-menu>
      </el-scrollbar>
    </el-aside>
  </div>
</template>
<script>
// import { obtainMenuList } from '@/api/menuList'
export default {
  props: {
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menuList: [
        // {
        //   children: [
        //     {
        //       children: [],
        //       createTime: '2021-04-23 13:53:09',
        //       id: 2,
        //       menuType: 'MENU',
        //       name: '企业列表',
        //       orderNum: 0,
        //       parentId: 1,
        //       perms: 'Role',
        //       url: '/dataManagement/enterpriseList'
        //     },
        //     {
        //       children: [],
        //       createTime: '2021-04-23 13:53:09',
        //       id: 3,
        //       menuType: 'MENU',
        //       name: '职位列表',
        //       orderNum: 0,
        //       parentId: 1,
        //       perms: 'Role',
        //       url: '/dataManagement/positionList'
        //     },
        //     {
        //       children: [],
        //       createTime: '2021-04-23 13:53:09',
        //       id: 4,
        //       menuType: 'MENU',
        //       name: '人才列表',
        //       orderNum: 0,
        //       parentId: 1,
        //       perms: 'Role',
        //       url: '/dataManagement/talentList'
        //     }
        //   ],
        //   createTime: '2021-04-13 13:13:22',
        //   icon: 'icon-jr-icon-data',
        //   id: 1,
        //   menuType: 'DIRECTORY',
        //   name: '数据管理',
        //   orderNum: 1,
        //   parentId: 0,
        //   perms: 'dataManagement',
        //   updateTime: '2021-04-23 13:39:05',
        //   url: '/dataManagement'
        // },
        // // 业务管理
        // {
        //   children: [
        //     {
        //       children: [],
        //       createTime: '2021-04-23 13:53:09',
        //       id: 6,
        //       menuType: 'MENU',
        //       name: '项目中心',
        //       orderNum: 0,
        //       parentId: 1,
        //       perms: 'Role',
        //       url: '/businessManagement/projectCenter'
        //     },
        //     {
        //       children: [],
        //       createTime: '2021-04-23 13:53:09',
        //       id: 7,
        //       menuType: 'MENU',
        //       name: '客户中心',
        //       orderNum: 0,
        //       parentId: 1,
        //       perms: 'Role',
        //       url: '/businessManagement/customerCenter'
        //     },
        //     {
        //       children: [],
        //       createTime: '2021-04-23 13:53:09',
        //       id: 8,
        //       menuType: 'MENU',
        //       name: '案例中心',
        //       orderNum: 0,
        //       parentId: 1,
        //       perms: 'Role',
        //       url: '/businessManagement/caseList'
        //     }
        //   ],
        //   createTime: '2021-04-13 13:13:22',
        //   icon: 'icon-jr-icon-business',
        //   id: 5,
        //   menuType: 'DIRECTORY',
        //   name: '业务管理',
        //   orderNum: 1,
        //   parentId: 0,
        //   perms: 'BusinessManagement',
        //   updateTime: '2021-04-23 13:39:05',
        //   url: '/businessManagement'
        // },
        // //系统管理
        // {
        //   children: [
        //     {
        //       children: [],
        //       createTime: '2021-04-23 13:53:09',
        //       id: 10,
        //       menuType: 'MENU',
        //       name: '菜单管理',
        //       orderNum: 0,
        //       parentId: 1,
        //       perms: 'Role',
        //       url: '/systemManagement/menuManagementList'
        //     },
        //     {
        //       children: [],
        //       createTime: '2021-04-23 13:53:09',
        //       id: 11,
        //       menuType: 'MENU',
        //       name: '用户管理',
        //       orderNum: 0,
        //       parentId: 1,
        //       perms: 'Role',
        //       url: '/systemManagement/userList'
        //     },
        //     // {
        //     //   children: [],
        //     //   createTime: '2021-04-23 13:53:09',
        //     //   id: 12,
        //     //   menuType: 'MENU',
        //     //   name: '消息提醒',
        //     //   orderNum: 0,
        //     //   parentId: 1,
        //     //   perms: 'Role',
        //     //   url: '/systemManagement/newsList'
        //     // },
        //     {
        //       children: [],
        //       createTime: '2021-04-23 13:53:09',
        //       id: 13,
        //       menuType: 'MENU',
        //       name: '权限设置',
        //       orderNum: 0,
        //       parentId: 1,
        //       perms: 'Role',
        //       url: '/systemManagement/jurisdiction'
        //     }
        //     // {
        //     //   children: [],
        //     //   createTime: '2021-04-23 13:53:09',
        //     //   id: 14,
        //     //   menuType: 'MENU',
        //     //   name: '项目日志',
        //     //   orderNum: 0,
        //     //   parentId: 1,
        //     //   perms: 'Role',
        //     //   url: '/systemManagement/journal'
        //     // }
        //   ],
        //   createTime: '2021-04-13 13:13:22',
        //   icon: 'icon-jr-icon-system',
        //   id: 9,
        //   menuType: 'DIRECTORY',
        //   name: '系统管理',
        //   orderNum: 1,
        //   parentId: 0,
        //   perms: 'systemManagement',
        //   updateTime: '2021-04-23 13:39:05',
        //   url: '/systemManagement'
        // }
      ], // 菜单列表
      activePath: '' // 当前路由
    }
  },
  created() {
    this.search()
  },
  methods: {
    //获取左侧菜单栏
    search() {
      this.menuList = JSON.parse(sessionStorage.getItem('menuTree')).map((outerItem) => {
        outerItem.children = outerItem.children.filter((innerItem) => innerItem.type !== '3')
        return outerItem
      })
    },
    // async search() {
    //   const { data: res } = await obtainMenuList()
    //   this.menuList = res.data
    // },
    saveNavState() {
      this.$store.dispatch('removeOtherQueryInfo')
    },
    handleClick() {}
  }
}
</script>
<style scoped lang="less">
.menuList {
  background-color: #ffffff;
  .el-menu {
    border: none;
  }
  ::v-deep .el-scrollbar__wrap {
    overflow-y: hidden;
  }

  a {
    text-decoration: none;
  }

  .router-link-active {
    text-decoration: none;
  }

  .one /deep/.is-active {
    background-color: #fbfbfb !important;
    border-left: 5px solid #17757a;
  }
  .el-menu-item {
    margin-left: 5px !important;
    height: 48px;
    line-height: 48px;
  }

  .iconfont {
    margin-right: 4px;
  }
  .superior {
    width: 200px;
    height: 48px;
    display: flex;
    align-items: center;
    padding-left: 20px;
    box-sizing: border-box;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
  }
  .img {
    width: 16px;
    height: 16px;
    margin-right: 5px;
  }
  .stance {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 5px;
  }
}
</style>
